import type { SVGProps } from "react";
export interface CloudWeatherSunBrightIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CloudWeatherSunBrightIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CloudWeatherSunBrightIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.567 7.064a4.875 4.875 0 1 1 6.399 6.357l-.109.04a1.125 1.125 0 0 1-.766-2.114l.226-.107a2.625 2.625 0 1 0-3.157-.51 1.125 1.125 0 0 1-1.64 1.542 4.88 4.88 0 0 1-.953-5.208m9.353 3.875a1.126 1.126 0 0 1 1.471-.61l1.039.43.104.05a1.125 1.125 0 0 1-.856 2.069l-.108-.04-1.04-.43a1.125 1.125 0 0 1-.61-1.47ZM7.101 5.629a1.126 1.126 0 0 1 1.471-.61l1.039.43.104.05a1.125 1.125 0 0 1-.856 2.069l-.108-.04-1.04-.43a1.125 1.125 0 0 1-.61-1.47Zm14.577-.648a1.125 1.125 0 0 1 .752 2.117l-1.039.43-.108.04a1.126 1.126 0 0 1-.753-2.118l1.04-.43zM11.77.961a1.125 1.125 0 0 1 1.47.608l.43 1.04.04.109a1.125 1.125 0 0 1-2.069.855l-.05-.104-.43-1.038A1.126 1.126 0 0 1 11.77.96Zm5.181.504a1.126 1.126 0 0 1 2.029.966l-.43 1.038-.05.104a1.125 1.125 0 0 1-2.03-.964l.431-1.04z"
      />
      <path
        fill={color}
        d="M18.875 18a2.88 2.88 0 0 0-2.158-2.785 1.125 1.125 0 0 1-.843-1.135l.001-.08a1.875 1.875 0 0 0-3.003-1.498 1.125 1.125 0 0 1-1.538-.173 3.375 3.375 0 0 0-5.918 2.704c.084.532-.22 1.05-.727 1.234a2.377 2.377 0 0 0 .81 4.608H16l.295-.015a2.876 2.876 0 0 0 2.58-2.86m2.25 0a5.125 5.125 0 0 1-4.862 5.118l-.264.007H5.5a4.625 4.625 0 0 1-2.374-8.593V14.5a5.625 5.625 0 0 1 9.256-4.295 4.12 4.12 0 0 1 5.68 3.101A5.13 5.13 0 0 1 21.126 18Z"
      />
    </svg>
  );
}
